export function formatDate(value: string | null, options?: Intl.DateTimeFormatOptions): string {
  if (!value) return "Sin fecha";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Fecha inválida";

  const formatterOptions: Intl.DateTimeFormatOptions =
    options && Object.keys(options).length > 0 ? options : { dateStyle: "medium" };

  return new Intl.DateTimeFormat("es-ES", formatterOptions).format(date);
}

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat("es-ES", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

export function slugify(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
